import React from 'react';
import BaseFeedbacks from '@framework/ui/Pages/Landing/Sections/Feedbacks';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import { feedbacksList } from '@/dataroom/ui/components/Landing/dealvdr/feedbacksList';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';

const Feedbacks = () => (
  <Section>
    <SectionContainer size="large">
      <SectionHeader
        title="Real, unsolicited feedback"
        description="We don't ask for testimonials. Below is unsolicited feedback we received in writing from clients."
      />
      <BaseFeedbacks
        cardStyle="modern"
        feedbacksList={ feedbacksList }
      />
    </SectionContainer>
  </Section>
);

export default Feedbacks;
